import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import tabgrid from "../../../../../utilities/TabGrid";
import {
    TopButtonAction,
    TopButtonPointAction,
} from "../../../../../componentsTopsa/buttons/TopButtons";


export default class KierowcaLogiTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            szczegoly: null
        };
        this.renderButtonyAkcji=this.renderButtonyAkcji.bind(this)
    }

    componentDidMount() {
    }

    renderButtonyAkcji(cell,row){
        return(
            <div>
                <TopButtonPointAction buttonIcon={'fa fa-eye'}
                                      disabled={!Boolean(row.dane)}
                                      onClick={()=>{
                                          this.setState({
                                          showModal: true,
                                          szczegoly: row.dane
                                      })}}
                                      titleContent={'Zobacz dokładne logi'} />
            </div>
        )
    }

    formatTyp(cell,row){
        if(cell === 'INFO'){
            return <span className={'label label-info'} style={{}}>{cell}</span>
        }
        else if(cell === 'DEBUG'){
            return <span className={'label label-warning'} style={{}}>{cell}</span>
        }
        else if(cell === 'ERROR'){
            return <span className={'label label-danger'} style={{}}>{cell}</span>
        }
        else return cell
    }

    render() {
        const options = {
            sizePerPageList: [10, 15, 30,50,100],
            noDataText: 'Brak pasujących rekordów',
            sizePerPage: this.props.ilosc,
            page: this.props.strona,
            onSizePerPageList: this.props.onSizePerPageList,
            onPageChange: this.props.onPageChange,
        };

        return (
            <div>
                <div>
                    <div className={'pull-right'} style={{fontSize: '12px', color: 'grey', padding: '5px', fontStyle: 'italic'}}>
                        Ilość wszystkich logów: {Boolean(this.props.pageable.totalElements) ? this.props.pageable.totalElements : 0}
                    </div>
                    <div>
                        <BootstrapTable data={this.props.data}
                                        options={options}
                                        pagination
                                        hover
                                        fetchInfo={{dataTotalSize: this.props.pageable.totalElements}}
                                        remote={true}
                        >
                            <TableHeaderColumn dataField='idMobLog' isKey hidden={false} thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                               dataFormat={(cell,row)=>{return <span style={{fontSize:'12px'}}>{cell}</span>}}
                                               dataSort
                            >ID
                            </TableHeaderColumn>
                            <TableHeaderColumn dataField='dataWpisu'  dataSort
                                               thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                               dataFormat={(cell,row)=>{return cell.replace('T',' ').substr(0,16)}}
                            >Data</TableHeaderColumn>
                            <TableHeaderColumn dataField='nazApp'  dataSort
                                               thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                               dataFormat={(cell,row)=>{return <span style={{fontSize:'12px'}}>{cell}</span>}}
                            >Aplikacja</TableHeaderColumn>
                            <TableHeaderColumn dataField='werApp'  dataSort
                                               thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                               dataFormat={(cell,row)=>{return <span style={{fontSize:'12px'}}>{cell}</span>}}
                            >Wersja</TableHeaderColumn>
                            <TableHeaderColumn dataField='nazUz'  dataSort
                                               thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                            >Użytkownik</TableHeaderColumn>
                            <TableHeaderColumn dataField='typBledu'  dataSort
                                               thStyle={tabgrid. tg1} tdStyle={tabgrid. tg1}
                                               dataFormat={this.formatTyp}
                            >Typ</TableHeaderColumn>
                            <TableHeaderColumn dataField='komunikat'  dataSort
                                               thStyle={tabgrid. tg3} tdStyle={tabgrid. tg3}
                                               dataFormat={(cell,row)=>{return <span style={{fontSize:'12px'}}>{cell}</span>}}
                            >Komunikat</TableHeaderColumn>
                            <TableHeaderColumn dataField='nrTelefonu'  dataSort
                                               thStyle={tabgrid. tg2} tdStyle={tabgrid. tg2}
                                               dataFormat={(cell,row)=>{return <span style={{fontSize:'12px'}}>{cell}</span>}}
                            >Nr telefonu</TableHeaderColumn>
                            <TableHeaderColumn dataField='modelTelefonu'  dataSort
                                               thStyle={tabgrid. tg2} tdStyle={tabgrid. tg2}
                                               dataFormat={(cell,row)=>{return <span style={{fontSize:'12px'}}>{cell}</span>}}
                            >Model</TableHeaderColumn>
                            <TableHeaderColumn dataField='werSystemu'  dataSort
                                               thStyle={tabgrid. tg1} tdStyle={tabgrid. tg1}
                                               dataFormat={(cell,row)=>{return <span style={{fontSize:'12px'}}>{cell}</span>}}
                            >Wersja syst</TableHeaderColumn>
                            <TableHeaderColumn dataField='ip'  dataSort
                                               thStyle={tabgrid. tg2} tdStyle={tabgrid. tg2}
                                               dataFormat={(cell,row)=>{return <span style={{fontSize:'12px'}}>{cell}</span>}}
                            >IP</TableHeaderColumn>
                            <TableHeaderColumn dataField='idMobLog'
                                               thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                               dataFormat={this.renderButtonyAkcji}
                            >Zobacz</TableHeaderColumn>
                        </BootstrapTable>
                    </div>
                </div>
                {
                    Boolean(this.state.szczegoly) && this.state.showModal?
                        <div id={'EBUSModalContainerBG'}>
                            <div id={'modalContainer'}>
                                <div id={'modalTextContent'} style={{width: '1000px'}}>
                                    <div>
                                        <div className={'pull-right'}>
                                            <TopButtonAction onClick={() => {
                                                this.setState({showModal: false, szczegoly: null})
                                            }}
                                                             elementStyle={{color: 'firebrick'}}
                                                             btnColor={'default'} text={'Zamknij'} iconType={'fa fa-times'}
                                            />
                                        </div>
                                        <div style={{clear: 'both', height:'5px'}}></div>
                                        <div>
                                            <div className={'thumbnail'} style={{maxWidth:'966px', maxHeight:'450px'}}>
                                                <div style={{padding:'5px', fontFamily:'monospace', overflow:'auto', maxHeight:"400px"}}>
                                                    {atob(this.state.szczegoly)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div style={{clear: 'both'}}></div>
                            </div>
                        </div>
                        :
                        ''
                }


            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/administracja/logi/kierowcyTab/components/KierowcaLogiTable.js